$(document).ready(function () {
  $(".footer-type-link_list .footer-block__heading").click(function () {

    const $parent = $(this).closest(".footer-type-link_list");
    const $content = $parent.find(".footer-block__details-content");

    $(".footer-type-link_list").not($parent).removeClass("active").find(".footer-block__details-content").slideUp();

    if ($parent.hasClass("active")) {
        $parent.removeClass("active");
        $content.slideUp();
    } else {
        $parent.addClass("active");
        $content.slideDown();
    }
  });

  $('.cls-actually--header').on('click', function () {
    $(".cls-actually-test-content").hide();

    $('.cls-actually--header').not(this).removeClass('active');

    $(this).addClass('active');

    const title = $(this).data('title');
    $(".actually--" + title).show();
  });

  $(".cls__accordion-heading").click(function () {
    const $parent = $(this).closest(".collapsibles_tab");
    const $content = $parent.find(".accordion__contents");

    $(".collapsibles_tab").not($parent).removeClass("active")
      .find(".accordion__contents").slideUp();

    if ($parent.hasClass("active")) {
      $parent.removeClass("active");
      $content.slideUp();
    } else {
      $parent.addClass("active");
      $content.slideDown();
    }
  });

});

$(window).on('load', function () {

  // slider
    $(".slider-for-one")
    .slick({
        infinite: true,
        autoplay:false,
        autoplaySpeed:3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: false,
        pauseOnHover:true
    });

  // end slider

  $(".cls-image-website-slider").slick({
      infinite: true,
      autoplay:true,
      autoplaySpeed:3000,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      pauseOnHover:true,
      responsive: [
          {
              breakpoint: 900,
              settings: {
                  slidesToShow: 2
              }
          }
      ]
  });
});

jQuery(function ($) {
    var $slider = $(".cls--img-text-slider-block");

    if (!$slider.length) return;

    if ($slider.hasClass("slick-initialized")) return;

    $slider.slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
});


$(function () {
  const $s = $(".slider-for-three-one").not(".slick-initialized");

  $s.slick({
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });

  $(window).on("load", function () {
    $(".slider-for-three-one.slick-initialized").slick("resize");
    $(".slider-for-three-one.slick-initialized").slick("setPosition");
  });

  $(window).on("resize orientationchange", function () {
    $(".slider-for-three-one.slick-initialized").slick("setPosition");
  });

});



$(function () {
  $(".cls-block-image-slider").not(".slick-initialized").each(function () {
    $(this).slick({
      infinite: true,
      autoplay: false,
      autoplaySpeed: 2000,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      centerMode: true,
      centerPadding: "0px",
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            centerMode: false, 
            centerPadding: "0px"
          }
        }
      ]
    });
  });

  $(window).on("load", function () {
    $(".cls-block-image-slider.slick-initialized").slick("setPosition");
  });
});

function initNumberAnimation() {

  if (window.matchMedia("(max-width: 768px)").matches) return;
  
  const counters = document.querySelectorAll(".animation-number");

  if (!counters.length) return;

  counters.forEach((el) => {
    if (!el.dataset.raw) {
      el.dataset.raw = el.textContent.trim();
    }
  });

  const animateNumber = (el, target, formatFn, onDone) => {
    const duration = 2000;
    const startTime = performance.now();

    const step = (t) => {
      const progress = Math.min((t - startTime) / duration, 1);
      const value = progress * target;
      el.textContent = formatFn(value);

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = formatFn(target);
        onDone && onDone();
      }
    };

    requestAnimationFrame(step);
  };

  const parseFormat = (raw) => {
    const text = raw.trim();

    const hasDollar = text.startsWith("$");
    const sign =
      text.startsWith("+") ? "+" :
      text.startsWith("-") ? "-" : "";

    const clean = text.replace(/[$,+-]/g, "");

    const match = clean.match(/^([\d.]+)([a-zA-Z%×]+)?$/);
    if (!match) return null;

    const num = parseFloat(match[1]);
    const suffix = (match[2] || "").toUpperCase();

    let target = num;
    let formatFn;

    if (suffix === "K" || suffix === "K+") {
      target = num * 1000;
      formatFn = (v) =>
        (hasDollar ? "$" : "") + Math.floor(v / 1000) + "K+";

    } else if (suffix === "M" || suffix === "M+") {
      target = num * 1_000_000;
      formatFn = (v) =>
        (hasDollar ? "$" : "") + Math.floor(v / 1_000_000) + "M";

    } else if (suffix === "%") {
      formatFn = (v) => sign + Math.floor(v) + "%";

    } else if (suffix === "X") {
      formatFn = (v) => v.toFixed(1) + "X";
    } else if (suffix === "×") {
      formatFn = (v) => v.toFixed(1) + "×";
    } else {
      formatFn = (v) =>
        (hasDollar ? "$" : "") + Math.floor(v) + suffix;
    }

    return { target, formatFn };
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target;
        const raw = el.dataset.raw;
        if (!raw) return;

        if (entry.isIntersecting) {
          if (el.dataset.animating === "1") return;

          const parsed = parseFormat(raw);
          if (!parsed) return;

          el.dataset.animating = "1";
          animateNumber(el, parsed.target, parsed.formatFn, () => {
            el.dataset.animating = "0";
          });
        } else {
          el.textContent = raw;
          el.dataset.animating = "0";
        }
      });
    },
    { threshold: 0.4 }
  );

  counters.forEach((el) => observer.observe(el));
}

/* Load lần đầu */
document.addEventListener("DOMContentLoaded", initNumberAnimation);

/* Dùng cho SPA / page transition */
window.initNumberAnimation = initNumberAnimation;


window.initBeforeAfter = function (root = document) {
  root.querySelectorAll(".ss_before_after_image").forEach(section => {
    if (section.dataset.init === "true") return; // tránh init lại

    const cursor = section.querySelector(".before-after__cursor");
    const imageWrapper = section.querySelector(".before-after-image-wrapper");

    if (!cursor || !imageWrapper) return;

    section.dataset.init = "true";

    let xStart = 0;
    let originalOffset = 0;

    function getCurrentOffset() {
      const inline = imageWrapper.style.getPropertyValue("--clip-path-offset");
      if (inline) return parseInt(inline);

      const computed = getComputedStyle(imageWrapper)
        .getPropertyValue("--clip-path-offset");

      return parseInt(computed) || 0;
    }

    function dragStart(e) {
      xStart = e.clientX;
      originalOffset = getCurrentOffset();

      document.addEventListener("pointermove", dragMove);
      document.addEventListener("pointerup", dragEnd);
    }

    function dragMove(e) {
      const diff = e.clientX - xStart;
      let result = originalOffset + diff;

      const percent = parseFloat(
        getComputedStyle(imageWrapper).getPropertyValue(
          "--before-after-initial-drag-position"
        )
      ) || 50;

      const width = imageWrapper.offsetWidth;
      if (!width) return;

      const pxOffset = (percent / 100) * width;

      result = Math.max(-pxOffset, Math.min(width - pxOffset, result));
      imageWrapper.style.setProperty("--clip-path-offset", result + "px");
    }

    function dragEnd() {
      document.removeEventListener("pointermove", dragMove);
      document.removeEventListener("pointerup", dragEnd);
    }

    cursor.addEventListener("pointerdown", dragStart);
  });
};
window.initBeforeAfter();


(function ($) {
  const pageCache = {};

  // OPEN
  $(document).on('click', '.view-case', function (e) {
    e.preventDefault();

    const url = $(this).attr('href');

    if (!url || url === '#') {
      return;
    }

    $('body').addClass('no-scroll');
    $('#target-content')
      .addClass('is-open is-loading');

    // Nếu đã cache → show ngay
    if (pageCache[url]) {
      $('.target-inner').html(pageCache[url]);
      $('#target-content').removeClass('is-loading');
      return;
    }

    $.get(url)
      .done(function (html) {
        const $doc = $('<div>').append($.parseHTML(html));
        const $content = $doc.find('#MainContent');

        if ($content.length) {
          const contentHTML = $content.html();
          pageCache[url] = contentHTML;
          $('.target-inner').html(contentHTML); 
          requestAnimationFrame(() => {
            if (window.initBeforeAfter) {
              window.initBeforeAfter(document.querySelector('.target-inner'));
            }
          });               
        }
      })
      .always(function () {
        $('#target-content').removeClass('is-loading');
      })
      .fail(function (err) {
        console.error(err);
      });
  });

  // CLOSE button
  $(document).on('click', '.cls-target-close', function () {
    closeTarget();
  });

  // ESC close
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      closeTarget();
    }
  });

  function closeTarget() {
    $('#target-content').removeClass('is-open is-loading');
    $('body').removeClass('no-scroll');
    $('.target-inner').empty();
  }

})(jQuery);


$(".footer-block--menu .footer-block__heading").click(function () {
  const $parent = $(this).closest(".footer-block--menu");
  const $content = $parent.find(".footer-block__details-content");

  $(".footer-block--menu").not($parent).removeClass("active")
    .find(".footer-block__details-content").slideUp();

  if ($parent.hasClass("active")) {
    $parent.removeClass("active");
    $content.slideUp();
  } else {
    $parent.addClass("active");
    $content.slideDown();
  }
});

$('.cls--case-study .case-study-logo').on('click', function () {
    var index = $(this).data('index');
    var url = $(this).data('url');

    // 1. Handle Active Tab Styling
    $('.cls--case-study .case-study-logo').removeClass('active');
    $(this).addClass('active');

    // 2. Hide ALL images and ALL text/link wraps
    $('.cls--case-study .cls-case-study-main-image').hide();
    $('.cls--case-study .case-study-link-wrap').hide();

    // 3. Show the image matching the index
    var activeImage = $('.cls--case-study .cls-case-study-main-image-' + index);
    activeImage.show();

    // 4. Show the text block that sits immediately AFTER that image
    activeImage.next('.case-study-link-wrap').show();

    // 5. Update the URL for the link inside the newly shown block
    $(".cls--case-study .case-study-link a").attr('href', url);
});

// 
if(!window.Util) window.Util = {};
Util.osHasReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

(function () {
  function StackCards(el) {
    this.element = el;
    this.items = el.getElementsByClassName('js-stack-cards__item');
    this.init();
  }

  StackCards.prototype.init = function () {
    this.marginY = 24;
    this.cardHeight = this.items[0].offsetHeight;
    this.cardTop = 32;
    window.addEventListener('scroll', this.animate.bind(this));
  };

  StackCards.prototype.animate = function () {
    const top = this.element.getBoundingClientRect().top;

    for (let i = 0; i < this.items.length; i++) {
      const offset = this.cardTop - top - i * (this.cardHeight + this.marginY);
      if (offset > 0) {
        const scale = Math.max(0.85, 1 - offset * 0.0008);
        this.items[i].style.transform =
          `translateY(${this.marginY * i}px) scale(${scale})`;
      }
    }
  };

  if (!Util.osHasReducedMotion()) {
    document
      .querySelectorAll('.js-stack-cards')
      .forEach(el => new StackCards(el));
  }
})();
